var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { class: _vm.classname, attrs: { title: _vm.username } },
    [
      _vm.country != null
        ? _c("omegaup-countryflag", { attrs: { country: _vm.country } })
        : _vm._e(),
      _vm.linkify
        ? [
            _vm.emitClickEvent
              ? _c(
                  "a",
                  {
                    class: _vm.classname,
                    attrs: { href: _vm.href, title: _vm.username },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("click", _vm.username)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.nameWithUsername))]
                )
              : _c(
                  "a",
                  {
                    class: _vm.classname,
                    attrs: {
                      title: _vm.username,
                      href: `/profile/${_vm.username}/`,
                    },
                  },
                  [_vm._v(_vm._s(_vm.nameWithUsername))]
                ),
          ]
        : [
            _vm._t("username-url", function () {
              return [_vm._v(" " + _vm._s(_vm.nameWithUsername) + " ")]
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }